<div class="chart-container" #container>
    <div *ngIf="hasData" [style.width]="cssWidth"> 
        <dx-chart
            [dataSource]="values"
            palette="climatixIc"
            #chart
        >
            <dxo-animation [enabled]="false"></dxo-animation>
            <dxo-legend
                [visible]="true"
                position="outside"
                horizontalAlignment="center"
                verticalAlignment="bottom"
            ></dxo-legend>
            <dxo-tooltip
                [enabled]="true"
                [customizeTooltip]="customizeTooltipBound"
            ></dxo-tooltip>
            <dxi-series
                *ngFor="let item of series"
                argumentField="group"
                [valueField]="item.valueField"
                [name]="item.name"
                [axis]="item.axis"
                [color]="item.color"
                type="bar"
            >
                <dxo-label
                    [visible]="showSeriesLabel"
                    [customizeText]="createSeriesLabelFormater(item)"
                ></dxo-label>
            </dxi-series>


            <dxi-value-axis
                *ngFor="let axis of axes"
                [name]="axis.name"
                [type]="axis.type"
                [position]="axis.position"
                [categories]="axis.categories"
                [valueMarginsEnabled]="false"
                [visualRange]="axis.visualRange"
                [tickInterval]="axis.tickInterval"
                [allowDecimals]="true"
                argumentType="string"
            >
                <dxo-title [text]="axis.title"></dxo-title>
                <dxo-grid [visible]="true"></dxo-grid>
                <dxo-minor-grid [visible]="true"></dxo-minor-grid>
                <dxo-label
                    [visible]="true"
                    [customizeText]="axis.formater"
                >
                </dxo-label>
            </dxi-value-axis>

            <dxo-argument-axis argumentType="string" [tickInterval]="0.1">
                <dxo-label
                    [visible]="true"
                    [customizeText]="argumentLabelFormaterBound"
                ></dxo-label>
            </dxo-argument-axis>

            <dxo-common-axis-settings
                argumentField="group"
                color="rgba(0, 0, 0, 0.8)"
            >
                <dxo-label [font]="{ color : '#000' }"></dxo-label>
            </dxo-common-axis-settings>

            <dxo-common-series-settings>
                <dxo-label [visible]="true"></dxo-label>
            </dxo-common-series-settings>

        </dx-chart>
    </div>
</div>


